import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import { Widget, WidgetGroup } from 'src/app/shared/models/widget.interface';

@Injectable({
  providedIn: 'root',
})
export class WidgetsApiService {
  private readonly widgetsUrl = '/widgets';
  private readonly usersUrl = '/users';

  constructor(private http: HttpService) {}

  /**
   * GET /api/widgets — full widget catalog grouped by panel then page.
   * Supports ?filter_by_group= (e.g. dealer_dashboard) and ?filter_by_page=
   */
  getWidgets(params: { filter_by_group?: string; filter_by_page?: string } = {}): Observable<ApiResponse<WidgetGroup[]>> {
    return this.http.getReq(this.widgetsUrl, { params });
  }

  /**
   * GET /api/users/{user}/widgets — the client's effective widgets.
   * Returns all widgets by default, or the assigned subset if one was set.
   */
  getUserWidgets(userId: number | string): Observable<ApiResponse<Widget[]>> {
    return this.http.getReq(`${this.usersUrl}/${userId}/widgets`);
  }

  /**
   * PUT /api/users/{user}/widgets — set the widget subset for a client.
   * Send an empty array to reset back to "all widgets".
   */
  setUserWidgets(userId: number | string, widgetIds: number[]): Observable<ApiResponse<any>> {
    return this.http.putReq(`${this.usersUrl}/${userId}/widgets`, { widget_ids: widgetIds });
  }
}
